import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';

import { AlertUtils, ParamUtils } from '../../../shared';
import { Account, Faculty, Queue } from '../../../models';
import { FacultyService, Principal } from '../../../services';
import { FACULTY_LIST_MODIFICATION, QUEUE_LIST_MODIFICATION } from '../../../shared/constants';

@Component({
    selector: 'qms-queues',
    templateUrl: './queues.component.html',
    styleUrls: ['./queues.component.css']
})
export class QueuesComponent implements OnInit, OnDestroy {
    public queues: Queue[];
    public faculties: Faculty[];
    public faculty: Faculty;
    public showEmptyFacultiesWarning: boolean;
    public showNoAccessToFacultiesWarning: boolean;

    private currentAccount: Account;
    private routeSubscription: Subscription;
    private facultySubscription: Subscription;
    private queueSubscription: Subscription;

    constructor(private principal: Principal,
                private eventManager: JhiEventManager,
                private alertService: JhiAlertService,
                private facultyService: FacultyService,
                private router: Router,
                private route: ActivatedRoute) {
        this.faculty = null;
        this.faculties = null;
        this.showEmptyFacultiesWarning = false;
        this.showNoAccessToFacultiesWarning = false;
    }

    ngOnInit() {
        this.reloadUserAndLoadFaculties();
        this.registerChangeInQueues();
    }

    private reloadUserAndLoadFaculties() {
        this.principal.identity(true).then((account: Account) => {
            this.currentAccount = account;
            this.loadFaculties();
        });
    }

    ngOnDestroy() {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
        this.eventManager.destroy(this.facultySubscription);
        this.eventManager.destroy(this.queueSubscription);
    }

    private loadQueues() {
        this.facultyService.findQueues(this.faculty.id).subscribe((queues: Queue[]) => {
            this.queues = queues;
        });
    }

    private loadFaculties() {
        this.principal.userFaculties().subscribe((faculties: Faculty[]) => {
            this.faculties = faculties;
            this.initializeCurrentFaculty();
        }, () => {
            this.faculties = [];
            this.initializeCurrentFaculty();
        });
    }

    private initializeCurrentFaculty() {
        this.routeSubscription = this.route.params.subscribe((params) => {
            ParamUtils.parseNumber(params['id'], (facultyId: number) => {
                // Case /queues/faculty/:id
                this.facultyService.find(facultyId).subscribe((faculty: Faculty) => {
                    if (this.principal.hasAccessToFaculty(faculty)) {
                        this.faculty = faculty;
                        this.loadQueues();
                    } else {
                        window.history.back();
                        AlertUtils.notifyAccessDenied(this.eventManager, this.alertService);
                    }
                }, (result) => {
                    // Faculty not exists
                    this.router.navigate(['management/queues']);
                });
            }, () => {
                // Case /queues
                if (this.faculties && this.faculties.length > 0) {
                    // Redirect to first item in menu
                    this.router.navigate(['management/queues/faculty', this.faculties[0].id]);
                } else {
                    this.facultyService.all().subscribe((faculties: Faculty[]) => {
                        if (faculties.length > 0) {
                            // No access to all faculties
                            this.showNoAccessToFacultiesWarning = true;
                        } else {
                            // There is no faculties
                            this.showEmptyFacultiesWarning = true;
                        }
                    });
                }
            }, () => {
                // Case :id is not a number
                window.history.back();
                AlertUtils.notifyNotFound(this.eventManager, this.alertService);
            });
        });
    }

    private registerChangeInQueues() {
        this.queueSubscription = this.eventManager.subscribe(QUEUE_LIST_MODIFICATION, (response) => {
            this.loadQueues();
        });
        this.facultySubscription = this.eventManager.subscribe(FACULTY_LIST_MODIFICATION, (response) => {
            this.reloadUserAndLoadFaculties();
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/queues/queues.component.ts